// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-step-indicator-bullet[data-v-024a5571]{margin-bottom:1rem\n}", "",{"version":3,"sources":["webpack://./../nn-psdl-modules/src/app-coupleEherkenning/views/ResetPassword.vue"],"names":[],"mappings":";AACA,0CAA0C;AAC1C","sourcesContent":["\n.c-step-indicator-bullet[data-v-024a5571]{margin-bottom:1rem\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
